class PwnageModal {
  constructor(modalEl) {
    this.modalEl = modalEl
    this.modalCloseEl = this.modalEl.querySelector(".close")
    this.modalBgEl = this.modalEl.querySelector(".modal__background")
    this.modalContainerEl = this.modalEl.querySelector(".modal__container")

    //this.bindUIActions()
  }

  bindUIActions() {
    this.modalEl.addEventListener("click", (event) => {
      if (
        event.target == this.modalCloseEl ||
        event.target == this.modalContainerEl ||
        event.target == this.modalBgEl
      ) {
        this.hide()
      }
    })
    window.addEventListener("scroll", (event) => {
      document.documentElement.style.setProperty(
        "--scroll-y",
        `${window.scrollY}px`
      )
    })
  }

  show() {
    const scrollY =
      document.documentElement.style.getPropertyValue("--scroll-y")
    const body = document.body
    body.style.position = "fixed"
    body.style.top = `-${scrollY}`
    this.modalEl.dataset.hide = "false"
    window.setTimeout(() => {
      this.modalEl.dataset.show = "true"
    }, 20)
  }

  hide() {
    const body = document.body
    const scrollY = body.style.top
    body.style.position = ""
    body.style.top = ""
    window.scrollTo(0, parseInt(scrollY || "0") * -1)
    this.modalEl.dataset.show = "false"
    window.setTimeout(() => {
      this.modalEl.dataset.hide = "true"
    }, 500)
  }
}

class PwnageModalAddToCart extends PwnageModal {
  constructor(modalEl, callback) {
    super(modalEl)
    this.checkBoxes = this.modalEl.querySelectorAll('input[type="checkbox"]')
    this.modalButton = this.modalEl.querySelector(".modal__button")
    this.modalPriceEl = this.modalEl.querySelector(".price-big")
    this.callback = callback

    this.bindUIActions()
    this.updateButton()

    if (this.modalEl.dataset.preview && Shopify.designMode) {
      this.show()
    }
  }

  bindUIActions() {
    super.bindUIActions()
    this.checkBoxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (event) => {
        this.updateButton()
      })
    })

    if (this.modalButton) {
      this.modalButton.addEventListener("click", (event) => {
        if (this.callback) this.callback()
        this.hide()
      })
    }
  }

  updateButton() {
    var toUpdate = true
    if (this.checkBoxes) {
      this.checkBoxes.forEach((checkbox) => {
        if (checkbox.checked == false) {
          toUpdate = false
        }
      })
    }
    if (this.modalButton) {
      this.modalButton.disabled = !toUpdate
    }
  }

  show() {
    if (this.checkBoxes) {
      this.checkBoxes.forEach((checkbox) => {
        checkbox.checked = false
      })
    }
    this.updateButton()
    this.modalPriceEl.innerHTML = document.getElementById(
      "product-price--dynamic"
    ).innerHTML
    super.show()
  }
}
